import { useContext } from 'react';
import { AuthContext, type AuthContextValue } from './authContext';

/** Access the Supabase auth session and the delegated auth actions. */
export function useAuth(): AuthContextValue {
  const value = useContext(AuthContext);
  if (!value) {
    throw new Error('useAuth must be used inside <AuthProvider>.');
  }
  return value;
}
